<br />
<div class="container mx-auto">
  <div>
    <h2>Schedules</h2>
    <app-system-wide-message></app-system-wide-message>
  </div>

  <div class="route-selection-mode" *ngIf="recent_routes.length > 0">
    <h4> Recently Visited </h4>
  </div>

  <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2">
    <ng-container *ngFor="let route of routes">
      <div class="col-sm-6 border-bottom mb-2" *ngIf="recent_routes.includes(route.id)">
        <a class="black-link" routerLink="/schedules/{{route.id}}">
          <div class="route-selection-header">
            <h5>{{ route.name }}</h5>
            <div  class="route-description">
              {{ route.description }}
            </div>
          </div>
        </a>
        <br />
        <br />
        <a routerLink="/routes/status/{{route.id}}">
          <div class="route-selection-status mb-2">
            <span [ngClass]="{'icon-inactive': route.isalert === false}">
              <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                *ngIf="route.issuspended == false">
              <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                *ngIf="route.issuspended == true">
            </span>
            <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
              <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
            </span>
            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
              <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
            </span>
            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
              <img class="status-icons" src="../../../assets/images/route-status/detour.png">
            </span>
            <span [ngClass]="{'icon-inactive': route.iselevator === false}">
              <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
            </span>
          </div>
        </a>

      </div>
    </ng-container>
  </div>

  <br />
  <br />

  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <a class="nav-link active" id="nav-bus-tab" data-toggle="tab" href="#nav-bus" role="tab" aria-controls="nav-bus"
        aria-selected="true">
        <div class="status-icons">
          <img class="status-icons" src="../../../assets/images/modes/bus/bus-status.png">

        </div>
        <span class="badge">
          Bus
        </span>
      </a>
      <a class="nav-link" id="nav-rail-tab" data-toggle="tab" href="#nav-rail" role="tab" aria-controls="nav-rail"
        aria-selected="false">
        <div class="status-icons">
          <img class="status-icons" src="../../../assets/images/modes/rail/rail-status.png">
        </div>
        <span class="badge">
          Rail
        </span>
      </a>
      <a class="nav-link" id="nav-subway-tab" data-toggle="tab" href="#nav-subway" role="tab" aria-controls="nav-subway"
        aria-selected="false">
        <div class="status-icons">
          <img class="status-icons" src="../../../assets/images/modes/bsl/bsl-status.png">
        </div>
        <span class="badge">
          Subway
        </span>
      </a>
      <a class="nav-link" id="nav-trolley-tab" data-toggle="tab" href="#nav-trolley" role="tab"
        aria-controls="nav-trolley" aria-selected="false">
        <div class="status-icons">
          <img class="status-icons" src="../../../assets/images/modes/trolley/trolley-status.png">
        </div>
        <span class="badge">
          Trolley
        </span>
      </a>
    </div>
  </nav>
  <div class="tab-content" id="nav-tabContent">
    <div class="tab-pane fade show active" id="nav-bus" role="tabpanel" aria-labelledby="nav-bus-tab">

      <br />

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-4">
        <ng-container *ngFor="let route of routes">
          <div class="col-sm-6 border-bottom mb-2" *ngIf="route.mode == 'Bus'">
            <a class="black-link" routerLink="/schedules/{{route.id}}">
              <div class="route-selection-header">
                <h5>{{ route.name }}</h5>
                <div  class="route-description">
                  {{ route.description }}
                </div>
              </div>
            </a>
            <br />
            <br />
            <a routerLink="/routes/status/{{route.id}}">
              <div class="route-selection-status mb-2">
                <span [ngClass]="{'icon-inactive': route.isalert === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                    *ngIf="route.issuspended == false">
                  <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                    *ngIf="route.issuspended == true">
                </span>
                <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                  <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                  <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                </span>
              </div>
            </a>

          </div>
        </ng-container>

      </div>

    </div>
    <div class="tab-pane fade" id="nav-rail" role="tabpanel" aria-labelledby="nav-rail-tab">

      <br />

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2">
        <ng-container *ngFor="let route of routes">
          <div class="col-sm-6 border-bottom mb-2" *ngIf="route.mode == 'Regional Rail'">
            <a class="black-link" routerLink="/schedules/{{route.id}}">
              <div class="route-selection-header">
                <h5>{{ route.name }}</h5>
                <div  class="route-description">
                  {{ route.description }}
                </div>
              </div>
            </a>
            <br />
            <br />
            <a routerLink="/routes/status/{{route.id}}">
              <div class="route-selection-status mb-2">
                <span [ngClass]="{'icon-inactive': route.isalert === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                    *ngIf="route.issuspended == false">
                  <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                    *ngIf="route.issuspended == true">
                </span>
                <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                  <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                  <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                </span>
              </div>
            </a>

          </div>
        </ng-container>

      </div>

    </div>
    <div class="tab-pane fade" id="nav-subway" role="tabpanel" aria-labelledby="nav-subway-tab">
      <br />
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2">
        <ng-container *ngFor="let route of routes">
          <div class="col-sm-6 border-bottom mb-2" *ngIf="subway_routes.includes(route.mode)">
            <a class="black-link" routerLink="/schedules/{{route.id}}">
              <div class="route-selection-header">
                <h5>{{ route.name }}</h5>
                <div  class="route-description">
                  {{ route.description }}
                </div>
              </div>
            </a>
            <br />
            <br />
            <a routerLink="/routes/status/{{route.id}}">
              <div class="route-selection-status mb-2">
                <span [ngClass]="{'icon-inactive': route.isalert === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                    *ngIf="route.issuspended == false">
                  <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                    *ngIf="route.issuspended == true">
                </span>
                <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                  <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                  <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                </span>
              </div>
            </a>

          </div>
        </ng-container>
      </div>
    </div>
    <div class="tab-pane fade" id="nav-trolley" role="tabpanel" aria-labelledby="nav-trolley-tab">
      <br />
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3">
        <ng-container *ngFor="let route of routes">
          <div class="col-sm-6 border-bottom mb-2" *ngIf="trolley_routes.includes(route.mode)">
            <a class="black-link" routerLink="/schedules/{{route.id}}">
              <div class="route-selection-header">
                <h5>{{ route.name }}</h5>
                <div class="route-description">
                  {{ route.description }}
                </div>
              </div>
            </a>
            <br />
            <br />
            <a routerLink="/routes/status/{{route.id}}">
              <div class="route-selection-status mb-2">
                <span [ngClass]="{'icon-inactive': route.isalert === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                    *ngIf="route.issuspended == false">
                  <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                    *ngIf="route.issuspended == true">
                </span>
                <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                  <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                  <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                </span>
              </div>
            </a>

          </div>
        </ng-container>
      </div>

    </div>
  </div>
</div>
<app-main-footer></app-main-footer>